<template>
  <div class="l-row">

    <form-group :label="$t('color.label')">
      <input class="form-select" v-model="item.from.color" :columns="3" readonly="readonly">
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('color.label')" :columns="3">
      <input v-model="item.to.color" class="form-select" readonly="readonly">
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      preset: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    components: {
      Panel,
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// ColorItem.vue?17cc04c2